<template>
  <div
    class="edit-retirement flex w-full justify-start"
    style="flex-direction: column"
  >
   <div ref="crewRetirement" style="height: calc(100vh - 220px); margin: 0 1rem">
      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="pb-4 ml-2 aisea-text-16-400-black">
          {{ localData.name }}さんの{{
            dateText
          }}を入力し、実行ボタンを押してください。
        </div>

        <div class="w-full" style="position: relative; margin-top: 10px;">
          <label class="vs-input--label">{{ dateText }}</label>
          <div
            style="position: absolute; top: 2.2rem; left: 0.8rem; z-index: 9"
          >
            <vs-icon icon="calendar_today" size="15px" />
          </div>
          <datepicker
            name="retirement_date"
            :language="ja"
            :format="formatter"
            :typeable="false"
            v-model="retirementDate"
            v-validate="'required'"
            :data-vv-as="dateText"
            ref="datePickerRetirementDate"
            :color="AISEA_COLOR.BLUE"
          ></datepicker>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('retirement_date')"
            >{{ errors.first("retirement_date") }}
          </span>
        </div>
      </div>
    </div>
    <vs-divider style="margin: 0" />
    <div class="flex w-full justify-end items-center">
      <div class="w-2/3 flex justify-end items-center">
        <div style="margin: 0.8rem">
          <vs-button
            type="flat"
            style="width: 6rem; padding: 0.4rem"
            :style="{ 'background-color': AISEA_COLOR.WHITE }"
            @click="onCancel"
            :color="AISEA_COLOR.GRAY"
            >キャンセル</vs-button
          >
        </div>
        <div style="margin: 0.8rem">
          <vs-button
            style="width: 6rem; padding: 0.4rem"
            @click="onSubmit"
            :disabled="!validateForm"
            :color="AISEA_COLOR.BLUE"
            >保存</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseCrewApi = AiseaApiFactory.get("enterpriseCrew");
import { ColorMixin } from "@/mixins";
import moment from 'moment-timezone';
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("crewLabor");
import Datepicker from "vuejs-datepicker";
import DatepickerMixin from "@/mixins/DatepickerMixin";

export default {
  name: "CrewAccountEdit",
  mixins: [ColorMixin, DatepickerMixin],
  components: {
    Datepicker,
  },
  props: {
    inputParam: Object,
    activeSidebarCrew: Boolean,
  },
  data () {
    return {
      enterpriseCrewId: null,
      localData: null,
      error: { message: null },
      retirementDate: "",
    };
  },
  computed: {
    isRetirement () {
      return this.inputParam.retirement_date &&  this.inputParam.retirement_date < moment().local().startOf('day').format('YYYY-MM-DD');
    },
    dateText () {
      return this.isRetirement ? "復職日" : "退職日";
    },
    validateForm () {
      return this.retirementDate.length !== 0 && !this.errors.any()
    }
  },
  methods: {
    ...mapActions(["fetchCrew"]),

    async initLocalData () {
      this.enterpriseCrewId = this.inputParam.id;
      this.localData = _.cloneDeep(this.inputParam);
    },

    async onSubmit () {

      if (this.isRetirement) {
        await this.onRejoin();
      } else {
        await this.onRetirement();
      }

      await this.fetchCrew();
      this.$emit('reloadList');
      this.$emit('close');

    },

    async onRetirement () {
      let payload = {
        birth_date: this.localData.birth_date,
        email_address: this.localData.email_address,
        name: this.localData.name,
        name_kana: this.localData.name_kana,
        phone_number: this.localData.phone_number,
        affiliated_companies: this.localData.affiliated_companies,
        employee_number: this.localData.employee_number,
        union_member: this.localData.union_member,
        postal_code: this.localData.postal_code,
        prefecture: this.localData.prefecture,
        address: this.localData.address,
        memo: this.localData.memo,
        retirement_date: moment(this.retirementDate).format("YYYY-MM-DD"),
      };

      const res = await enterpriseCrewApi.update(this.localData.id, payload)
      if (!res || !res.status) {
        this.$vs.notify({
          title: `船員基本情報編集`,
          text: `${this.localData.name}の退職設定に失敗しました。時間を空けて再度試みてください。`,
          color: "danger",
          icon: "done"
        });
        return;
      }

      this.$vs.notify({
        title: `船員基本情報編集`,
        text: `${this.localData.name}のの退職設定が完了しました。`,
        color: "success",
        icon: "done"
      });

    },

    async onRejoin () {
      let payload = {
        birth_date: this.localData.birth_date,
        email_address: this.localData.email_address,
        name: this.localData.name,
        name_kana: this.localData.name_kana,
        phone_number: this.localData.phone_number,
        affiliated_company: this.localData.affiliated_company,
        employee_number: this.localData.employee_number,
        employment_status: this.localData.employment_status,
        union_member: this.localData.union_member,
        retirement_date: null,
      };

      const res = await enterpriseCrewApi.update(this.localData.id, payload)

      if (!res || !res.status) {
        this.$vs.notify({
          title: `船員基本情報編集`,
          text: `${this.localData.name}の復職設定に失敗しました。時間を空けて再度試みてください。`,
          color: "danger",
          icon: "done"
        });
        return;
      }

      this.$vs.notify({
        title: `船員基本情報編集`,
        text: `${this.localData.name}の復職設定が完了しました。`,
        color: "success",
        icon: "done"
      });
    },

    onCancel () {
      this.localData = {};
      this.enterpriseCrewId = null;
      this.$nextTick(() => {
        this.$emit('close');
      });
    },

  },
  created () {
    this.initLocalData();
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.edit-retirement {
  label {
    font-family: $aisea-font-family;
    font-size: 14px;
    font-weight: 600;
  }

  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
    }
  }

  .v-select input {
    height: 2rem;
  }

  .description_label {
    font-size: 0.8rem;
  }

  .crew-edit-form-row {
    flex-direction: column;
    margin: 24px 0;
    padding-right: 8px;
  }

  .vs__search::placeholder {
    color: lightgray;
  }

  .vdp-datepicker__calendar {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    .selected{
      background: $aisea-blue !important;
    }
  }

  .vdp-datepicker input {
    padding-left: 2.4rem;
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    &::placeholder {
      color: $aisea-light-gray;
      font-size: smaller;
    }
  }

  .vs-collapse-item--header {
    padding: 0;
  }
  .vs-collapse-item {
    border-bottom: none;
  }
}
</style>
